import { RouteObject } from 'react-router-dom';
import { Layout } from './Layout';
import { EventLayout } from './layouts/EventLayout';
import { ErrorPage } from './pages/ErrorPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { Home } from './pages/Home';
import { TicketsPage } from './pages/Tickets';
import { TicketDetails } from './pages/TicketDetails';
import { OrderDetails } from './pages/OrderDetails';
import { BusTicketsPage } from './pages/BusTickets';
import { BusOrderDetails } from './pages/BusOrderDetails';
import { FaqPage } from './pages/FAQ';
import { AwarenessPage } from './pages/AwarenessPage';
import { ProgramPage } from './pages/ProgramPage';
import { ImprintPage } from './pages/ImprintPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { UnsubscribePage } from './pages/UnsubscribePage';
import { EventLanding } from './pages/events/EventLanding';
import { EventTicketsPage } from './pages/events/EventTicketsPage';
import { EventTicketDetails } from './pages/events/EventTicketDetails';
import { EventOrderDetails } from './pages/events/EventOrderDetails';

/**
 * Two strictly separate layout systems:
 *  - Festival site (global nav + DE/EN) under the festival `Layout`.
 *  - Event microsites under `EventLayout` — own self-contained chrome, themed
 *    per event. The festival menu NEVER renders here. All event-owned ticket /
 *    order detail routes are nested under `events/:eventSlug` so they always
 *    render in that event's themed layout.
 */
export const routes: RouteObject[] = [
  {
    path: 'events/:eventSlug',
    element: <EventLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <EventLanding /> },
      { path: 'tickets', element: <EventTicketsPage /> },
      { path: 'tickets/:ticketId', element: <EventTicketDetails /> },
      { path: 'orders/:orderId', element: <EventOrderDetails /> },
    ],
  },
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      { path: 'tickets', element: <TicketsPage /> },
      { path: 'tickets/:ticketId', element: <TicketDetails /> },
      { path: 'orders/:orderId', element: <OrderDetails /> },
      { path: 'bus-tickets', element: <BusTicketsPage /> },
      { path: 'bus_orders/:orderId', element: <BusOrderDetails /> },
      { path: 'bus_orders/:orderId/:ticketId', element: <BusOrderDetails /> },
      { path: 'info', element: <FaqPage /> },
      { path: 'awareness', element: <AwarenessPage /> },
      { path: 'program', element: <ProgramPage /> },
      { path: 'imprint', element: <ImprintPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'unsubscribe', element: <UnsubscribePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
